import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { __decorate } from "tslib";
import StandardButton from "@/components/buttons/StandardButton.vue";
import { Component, Prop, Vue } from "vue-facing-decorator";
import WInput from "@/components/form/w-input.vue";
import QuizReadonlyAlert from "@/components/quiz/QuizReadonlyAlert.vue";
import QuizCheckableTextQuestion from "@/components/quiz/QuizCheckableTextQuestion.vue";
import QuizSimpleTextQuestion from "@/components/quiz/QuizSimpleTextQuestion.vue";
import QuizQuestionLabel from "@/components/quiz/QuizQuestionLabel.vue";
import PollQuizStatistics from "@/components/quiz/PollQuizStatistics.vue";
import axios from "axios";
import WElMessage from "@/components/wrappers/w-elmessage.vue";
import WSelect from "@/components/form/w-select.vue";
let SpeachPollsResults = class SpeachPollsResults extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "speachId", void 0);
    _defineProperty(this, "pollsResults", []);
    _defineProperty(this, "selectedPollId", '');
    _defineProperty(this, "pollsSelectItems", []);
    _defineProperty(this, "currentPollQuizStatistics", null);
    _defineProperty(this, "BASE_API_SPEACH", '/api/v2/speach');
  }
  mounted() {
    this.getSpeachPollsStatistics();
  }
  getSpeachPollsStatistics() {
    axios.get(`${this.BASE_API_SPEACH}/polls-results?speachID=${this.speachId}`, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      this.pollsResults = response.data;
      this.pollsSelectItems = this.pollsResults.map(pollStatisticsData => {
        return {
          id: `${pollStatisticsData.id}`,
          label: pollStatisticsData.questionLabel
        };
      });
      this.selectedPollId = this.pollsSelectItems[0]?.id || '';
      this.currentPollQuizStatistics = this.pollsResults[0];
    }).catch(() => {
      WElMessage.showErrorMessage(this.$t('errors.default'));
    });
  }
  onOptionChange(selectedId) {
    this.selectedPollId = selectedId;
    this.currentPollQuizStatistics = this.pollsResults.find(pollStatisticsData => `${pollStatisticsData.id}` === selectedId) || null;
  }
};
__decorate([Prop({
  required: true
})], SpeachPollsResults.prototype, "speachId", void 0);
SpeachPollsResults = __decorate([Component({
  components: {
    WSelect,
    PollQuizStatistics,
    QuizQuestionLabel,
    QuizSimpleTextQuestion,
    QuizCheckableTextQuestion,
    QuizReadonlyAlert,
    WInput,
    StandardButton
  }
})], SpeachPollsResults);
export default SpeachPollsResults;